/** One initial web reveal; no movement, and no animation for reduced motion. */
export function initialRevealOptions(isWeb: boolean, reducedMotion: boolean) {
  return isWeb && !reducedMotion
    ? { opacity: 0, duration: 140, settleFrames: 2 }
    : { opacity: 1, duration: 0, settleFrames: 0 }
}
